/* eslint-disable max-len */
export default {
    ADD_TO_CART: 'In den Warenkorb legen',
    ADD_TO_WISHLIST: 'Zur Wunschliste hinzufügen',
    APPLY: 'Anwenden',
    CALL_US: 'Rufe uns an',
    CANCEL: 'Abbrechen',
    CHOOSE_OPTION: 'Choisissez une option',
    COMPLETED: 'Vollständig',
    COMPONENTS: 'Komponenten',
    COPY: 'Kopiere den Link zu Deinem Design',
    COPIED: 'url in die Zwischenablage kopiert',
    CUSTOMER_SERVICE: 'Besoin d\'aide ? Notre Service Clients est à votre écoute',
    DETAILS: 'Details',
    DIFFERENT_SIZE: 'Verschiedene Größen für jeden Fuß?',
    DONE_FOR_NOW: 'Mit dem Anpassen fertig?',
    EMAIL: 'E-mail',
    EMAIL_DESIGN: 'Design mailen',
    EMAIL_INVALID: 'Bitte gib eine gültige E-Mail Adresse ein.',
    EMAIL_SENT: 'Vielen Dank! Ein Link zu Deinen persönlichen MyJoys wurde an Deinen Freund gesendet.',
    EMAIL_SUMMARY: 'MyJoys: E-Mail Zusammenfassung',
    ENTER_EMBROIDERY: 'Individuelle Stickerei eingeben',
    HELP: 'HILFE',
    HOURS: 'M-F 9:00 Uhr bis 17:00 Uhr',
    INVALID_ERROR: 'Dieses Feld enthält einen ungültigen Begriff',

    MAKE_A_SELECTION: 'Triff eine Auswahl, um fortzufahren',
    MAX_LENGTH_6: 'Maximal 6 Zeichen für Block erlaubt',
    MAX_LENGTH_3: 'Maximal 3 Ziechen für den Schriftzug erlaubt',
    MENS: 'Herren',
    MESSAGE: 'Ecrivez',
    MESSAGE_US: 'Kontaktiere uns',
    NEED_HELP: 'Du benötigst Hilfe? Unser Kundenservice-Tesam hilft Dir gerne weiter.',
    NONE_SELECTED: 'Keine ausgewählt',
    OK: 'Ok',
    PERSONALIZATION_POLICY: 'Richtlinien',
    PHONE_NUMBER: '08003668569',
    PHONE_NUMBER_FORMATTED: '0800 3668569',
    PRINT: 'Design drucken',
    RECIPIENT_NAME: 'Name des Empfängers',
    RECIPIENT_EMAIL: 'E-Mail des Empfängers',
    REQUIRED: 'Dieses Feld ist erforderlich.',
    RESET: 'Zurücksetzen',
    RESET_CONFIRM: 'Möchtest du alle Auswahlen zurücksetzen?',
    RESET_CONFIRM_COPY: 'Wenn Du fortfährst, werden alle Auswahlen zurückgesetzt und Dein Entwurf geht verloren.',
    SAVE: 'Speichern',
    SAVE_EXIT: 'Speichern & Schließen',
    SELECT_SIZE: 'Größe auswählen',
    SELECT_WIDTH: 'Weite auswählen',
    LEFT_SHOE_SIZE: 'Linke Schuhgröße',
    RIGHT_SHOE_SIZE: 'Rechte Schuhgröße',

    SEND_COPY: 'Sende eine Kopie dieser E-Mail an',
    SHARE: 'TEILEN',
    SHARE_DESIGN: 'Teile Dein Design',
    SIZE_GUIDE: 'Größenratgeber',
    SUBMIT: 'Absenden',
    UNDO: 'RÜCKGÄNGIG',
    VIEW_ALL: 'ALLE ANSEHEN',
    WEVE_GOT_YOU: 'Wir haben alles für Dich! Wenn Du diese Seite verlässt, wird Deine MyJoys-Auswahl in Deinen Designs gespeichert, damit Du später damit fortfahren kannst',
    WOMENS: 'Damen',
    YOUR_NAME: 'Dein Name',
    YOUR_EMAIL: 'Deine E-Mail',
    INSTANCE_ERROR_HEADER: 'Beim Abspeichern Ihrer Auswahl ist ein Fehler aufgetreten',
    INSTANCE_ERROR_BODY: 'Wir können derzeit Ihre Auswahl leider nicht speichern. Bitte versuchen Sie es zu einem späteren Zeitpunkt.',
    UPDATE_CART: 'Warenkorb aktualisieren',
    PERSONALIZE_CHOOSE_OPTION: 'Wähle eine Option',
    PERSONALIZE_SAME_LEFT: 'Identisch zum linken Schuh',
    PERSONALIZE_SAME_RIGHT: 'Identisch zum rechten Schuh',
    PERSONALIZE_NONE: 'Keine',
    PERSONALIZE_LOGO: 'Logo',
    PERSONALIZE_MONOGRAM: 'Monogramm',
    MONOGRAM_COLOR: 'Farbe des Monogramms',
};
